import React from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import style from './ContactMe.module.scss';
import {FormField, Input} from "../../../../components";
import {saveAdvisorContact} from '../../../../redux/action/advisor.action';
import {toast} from "react-toastify";

class ContactMe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      phone: '',
      email: '',
      description: '',
      loading: false
    }
  }

  async save() {
    const { name, phone, email, description } = this.state;
    if (!name) {
      toast.warn('لطفا نامتان را وارد کنید.');
      return ;
    }
    if (!phone) {
      toast.warn('لطفا شماره تماستان را وارد کنید.');
      return ;
    }
    this.setState({loading: true});
    try {
      await this.props.saveAdvisorContact({name, phone, email, description, advisor: this.props.advisor.id});
      toast.success('درخواست شما با موفقیت ارسال شد.');
      this.setState({ name: '', phone: '', email: '', description: ''});
    } finally {
      this.setState({loading: false});
    }
  }

  render() {
    const { name = '', phone = '', email = '', description = '', loading} = this.state;
    return (
      <div className={`${style.contact_me} d-flex flex-column`}>
        <div className={style.title}>
          <span>درخواست تماس</span>
        </div>
        <div>
          <FormField>
            <Input type={'text'} label={'نام'} placeholder={'نام'} value={name} onChange={(value) => {
              this.setState({name: value})
            }}/>
          </FormField>
        </div>
        <div>
          <FormField>
            <Input type={'text'} label={'شماره تماس'} placeholder={'شماره تماس'} value={phone} onChange={(value) => {
              this.setState({phone: value})
            }}/>
          </FormField>
        </div>
        <div>
          <FormField>
            <Input type={'text'} label={'ایمیل (اختیاری)'} placeholder={'ایمیل (اختیاری)'} value={email} onChange={(value) => {
              this.setState({email: value})
            }}/>
          </FormField>
        </div>
        <div>
          <FormField>
            <Input type={'text'} label={'توضیحات‌ (اختیاری)'} placeholder={'توضیحات‌ (اختیاری)'} value={description} onChange={(value) => {
              this.setState({description: value})
            }}/>
          </FormField>
        </div>
        <div>
          <button disabled={loading} type="button" className={`btn btn-secondary btn-sm ${style.send_button} text-center`} onClick={() => {
            this.save();
          }}>
            ارسال درخواست تماس
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  saveAdvisorContact: (data) => dispatch(saveAdvisorContact(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContactMe));
